<template>
  <center>
    <h1>Page Not Found!</h1>
    <p>
      <a href="/">Home</a>
    </p>
  </center>
</template>

<script>

  export default {
    name: 'PageNotFound'
  }

</script>

<style scoped>

  center {
    margin: 15vw;
  }

  h1 {
    color: var(--border);
    font-size: 2em;
  }

</style>
